import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Crown } from "lucide-react";

const FRONT_OFFICE = [
    ["General Manager / Founder / President of Basketball Operations", "Michael Lewis"],
    ["VP of Basketball Operations", "Sondree Allen"],
    ["Head Coach", "Eric Keppard"],
    ["Team Manager", "Ariel Sherrard"],
    ["Team Fitness Manager", "Jarae Adams"],
];

const VENUE = [
    ["Home City", "Fulshear, Texas"],
    ["Home Site", "Fulshear High School Sports Center"],
    ["Practice Facility", "Legends Sport Court · Katy, Texas"],
];

export default function Roster() {
    const [players, setPlayers] = useState([]);
    useEffect(() => { api.get("/players").then((r) => setPlayers(r.data)); }, []);

    return (
        <div data-testid="roster-page" className="grain">
            {/* Header */}
            <section className="border-b border-line py-16 md:py-24 bg-bg-soft">
                <div className="max-w-7xl mx-auto px-5 md:px-10">
                    <div className="text-gold text-xs tracking-[0.4em] uppercase font-bold mb-4">2025-2026 Season</div>
                    <h1 className="h-display text-6xl md:text-8xl">The Roster</h1>
                    <div className="mt-6 inline-flex items-center gap-2 px-3 py-1.5 border border-gold/50 bg-gold/10 text-gold text-[10px] tracking-[0.3em] uppercase font-black" data-testid="roster-champions">
                        <Crown size={12} /> 2024–2025 South Central Alpha Blue Wild Card Champions
                    </div>
                </div>
            </section>

            {/* Front office + venue */}
            <section className="max-w-7xl mx-auto px-5 md:px-10 py-14 grid md:grid-cols-2 gap-8">
                <div className="card-flat p-6" data-testid="front-office">
                    <div className="text-gold text-[10px] tracking-[0.4em] uppercase font-bold mb-4">Front Office</div>
                    <dl className="space-y-3">
                        {FRONT_OFFICE.map(([role, name]) => (
                            <div key={role} className="border-b border-line pb-2 last:border-none last:pb-0">
                                <dt className="text-[10px] tracking-[0.25em] uppercase text-ink">{role}</dt>
                                <dd className="text-white font-bold text-sm mt-1">{name}</dd>
                            </div>
                        ))}
                    </dl>
                </div>
                <div className="card-flat p-6" data-testid="venue-info">
                    <div className="text-gold text-[10px] tracking-[0.4em] uppercase font-bold mb-4">Home &amp; Facilities</div>
                    <dl className="space-y-3">
                        {VENUE.map(([label, val]) => (
                            <div key={label} className="border-b border-line pb-2 last:border-none last:pb-0">
                                <dt className="text-[10px] tracking-[0.25em] uppercase text-ink">{label}</dt>
                                <dd className="text-white font-bold text-sm mt-1">{val}</dd>
                            </div>
                        ))}
                    </dl>
                </div>
            </section>

            {/* Player table */}
            <section className="max-w-5xl mx-auto px-5 md:px-10 pb-24">
                <div className="text-gold text-[10px] tracking-[0.4em] uppercase font-bold mb-4">Players</div>
                <div className="border border-line overflow-x-auto">
                    <table className="w-full text-sm" data-testid="roster-table">
                        <thead className="bg-bg-soft border-b border-line">
                            <tr className="text-[10px] tracking-[0.3em] uppercase text-ink">
                                <th className="text-left px-4 py-3 w-16">#</th>
                                <th className="text-left px-4 py-3">Name</th>
                                <th className="text-left px-4 py-3 w-24">Height</th>
                                <th className="text-left px-4 py-3">Position</th>
                            </tr>
                        </thead>
                        <tbody>
                            {players.map((p) => (
                                <tr key={p.id} className="border-b border-line last:border-none hover:bg-purple-dark/20 transition-colors" data-testid={`player-${p.id}`}>
                                    <td className="px-4 py-3 h-display text-gold text-2xl">
                                        {p.jersey_number != null ? p.jersey_number : "—"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-white">{p.name}</td>
                                    <td className="px-4 py-3 text-ink">{p.height || "—"}</td>
                                    <td className="px-4 py-3 text-white/80">{p.position || "—"}</td>
                                </tr>
                            ))}
                            {players.length === 0 && (
                                <tr><td colSpan={4} className="p-12 text-center text-ink">No players yet.</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    );
}
